export const QUOTE_INFO = 'session_key_quote_info';

export const PICKED_PLAN_INFO = 'session_key_picked_plan_info';

export const STILL_NEED_CACHE = 'session_key_still_need_cache';

export const FIRST_STEP_INFO_FAST_QUOTE =
  'session_key_first_step_info_in_fast_quote';
